import React from 'react';
import { useTranslation } from 'react-i18next';

import { UnstyledButton } from '../../common/resetUI';
import { useLogout } from 'src/hooks/useLogout';

type LogoutProps = {
  className?: string;
};

const Logout: React.FC<React.PropsWithChildren<LogoutProps>> = ({
  className,
}) => {
  const logout = useLogout();
  const { t } = useTranslation('app');
  return (
    <UnstyledButton className={className} onClick={logout}>
      {t('navbar.signOut')}
    </UnstyledButton>
  );
};

export default Logout;
